import { ReportColumnPersonalizationFlags } from '../columnUtils.types';
import {
  CommissionReportTableGroupingColumnId,
  CommissionReportTableValueColumnId,
} from './commissionColumnUtils.types';

export const COMMISSION_REPORT_V2_TABLE_COLUMN_PERSONALIZATION_CONFIG_OVERRIDES: Record<
  string,
  Partial<ReportColumnPersonalizationFlags>
> = {
  [CommissionReportTableGroupingColumnId.EventDateLocal]: {
    isDateTime: true,
  },
  [CommissionReportTableGroupingColumnId.FulfillmentDate]: {
    isDateTime: true,
  },
  [CommissionReportTableGroupingColumnId.LastPaymentDate]: {
    isDateTime: true,
  },
  [CommissionReportTableGroupingColumnId.CommissionEligibilityDate]: {
    isDateTime: true,
  },
  [CommissionReportTableGroupingColumnId.NetCommissionRateOverride]: {
    isPercent: true,
  },
  [CommissionReportTableGroupingColumnId.NetCommissionRate]: {
    isPercent: true,
  },
  [CommissionReportTableGroupingColumnId.SaleBasisShare]: {
    isPercent: true,
  },
  [CommissionReportTableValueColumnId.TotalNetProceeds]: {
    isNumeric: true,
    isCurrency: true,
  },
  [CommissionReportTableValueColumnId.Credits]: {
    isNumeric: true,
    isCurrency: true,
  },
  [CommissionReportTableValueColumnId.TotalCost]: {
    isNumeric: true,
    isCurrency: true,
  },
  [CommissionReportTableValueColumnId.Charges]: {
    isNumeric: true,
    isCurrency: true,
  },
  [CommissionReportTableValueColumnId.CommissionerCostsAndCharges]: {
    isNumeric: true,
    isCurrency: true,
  },
  [CommissionReportTableValueColumnId.CommissionerProceedsAndCredits]: {
    isNumeric: true,
    isCurrency: true,
  },
  [CommissionReportTableValueColumnId.CommissionerProfitAndLoss]: {
    isNumeric: true,
    isCurrency: true,
  },
  [CommissionReportTableValueColumnId.OriginalProceeds]: {
    isNumeric: true,
    isCurrency: true,
  },
};
